"use client";

import { c as _c } from "react/compiler-runtime";
import { QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { Suspense } from "react";
import { MarketingCapture } from "@/components/marketing/marketing-capture";
import { ProgressBar } from "@/components/progress-bar";
import { queryClient } from "@/config/react-query";
import { IsMobileProvider } from "@/contexts/is-mobile-provider";
import { SelfScheduleProvider } from "@/contexts/self-schedule-provider";
import { PatientClaimProbe } from "@/hooks/patient-claim/use-patient-claim";
import { useRwgToken } from "@/hooks/self-schedule/use-rwg-token";
import { BookingEventGate } from "./components/booking-event-gate";
import { BookingEventBar } from "./components/booking-event-pass";
import { PatientDetailsGate } from "./components/patient-details-gate";
import { UrlPrefillContextBanner } from "./components/url-prefill-context-banner";
function RwgTokenCapture() {
  useRwgToken();
  return null;
}
export default function SelfScheduleLayoutClient(t0) {
  const $ = _c(10);
  const {
    children
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <PatientClaimProbe />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  let t3;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <Suspense fallback={null}><RwgTokenCapture /></Suspense>;
    t3 = <MarketingCapture />;
    $[1] = t2;
    $[2] = t3;
  } else {
    t2 = $[1];
    t3 = $[2];
  }
  let t4;
  let t5;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <BookingEventBar className="md:hidden" />;
    t5 = <UrlPrefillContextBanner />;
    $[3] = t4;
    $[4] = t5;
  } else {
    t4 = $[3];
    t5 = $[4];
  }
  let t6;
  if ($[5] !== children) {
    t6 = <div className="flex h-screen w-screen flex-col bg-background/70">{t4}{t5}<div className="min-h-0 flex-1 overflow-y-auto"><BookingEventGate><PatientDetailsGate>{children}</PatientDetailsGate></BookingEventGate></div></div>;
    $[5] = children;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = process.env.NODE_ENV === "development" && process.env.NEXT_PUBLIC_TANSTACK_DEVTOOLS === "true" && <ReactQueryDevtools initialIsOpen={false} />;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  if ($[8] !== t6) {
    t8 = <IsMobileProvider><QueryClientProvider client={queryClient}><SelfScheduleProvider>{t1}{t2}{t3}<ProgressBar className="fixed top-0 z-50 h-1 bg-primary">{t6}{t7}</ProgressBar></SelfScheduleProvider></QueryClientProvider></IsMobileProvider>;
    $[8] = t6;
    $[9] = t8;
  } else {
    t8 = $[9];
  }
  return t8;
}